import { useEffect } from "react";
import { NavLink } from "react-router-dom";

interface NavMenuModalProps {
  hideNavMenu: () => void;
}

export default function NavMenuModal(props: NavMenuModalProps) {
  useEffect(() => {
    // Anything in here is fired on component mount.
    document.body.style.overflow = "hidden";
    return () => {
      // Anything in here is fired on component unmount.
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div className="fixed z-10 flex h-full w-full flex-col items-center justify-center gap-5 bg-light-black">
      <NavLink to={"/"} onClick={props.hideNavMenu}>
        {" "}
        <h1 className="w-full rounded-xl border-2 p-5 transition duration-300 hover:scale-110">
          home
        </h1>{" "}
      </NavLink>
      <NavLink to={"/about"} onClick={props.hideNavMenu}>
        {" "}
        <h1 className="w-full rounded-xl border-2 p-5 transition duration-300 hover:scale-110">
          about
        </h1>{" "}
      </NavLink>
    </div>
  )
}
